const e = Array.isArray || function(r) {
  return r != null && r.length >= 0 && Object.prototype.toString.call(r) === "[object Array]";
};
export {
  e as default
};
